import BasicDetailsRepository from "@adapters/features/BasicProfile/Repository/BasicProfile";
import { accountDetails } from "@di";
export default (http) => {
    return {
        basicProfile: new BasicDetailsRepository(http, accountDetails),
    };
};
